import Vue from "vue";
import {ActionTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import VueI18n from '../../helpers/i18n';

import {Profile, Company} from '@/store/modules/lib'
import {ServerCompany} from '@/utils/ServerCompany';

export interface State {
  profiles: Profile[];
  plan: string;
  versionClient: string;
  loadStatus?: string;
  userCompany: Company | null;
  standCompanies: Company[];
}

const defaultState: State = {
  versionClient: "",
  plan: "",
  profiles: [],
  loadStatus: "",
  userCompany: null,
  standCompanies: [],
};

const getters = {
  plan: (state: State) => state.plan,
  profiles: (state: State) => state.profiles,
  profilesMap(state: State) {
    let map =
    state.profiles.map((el) => {
      return {id: el._id, text: el.name.first + ' ' + el.name.last}
    })
    map.unshift({id: 'all', text: VueI18n.t('shardList.filter.filter_fio.items.all').toString()})
    return map
  },

  userCompany: (state: State) => state.userCompany
  // name: (state: State) => state.profile ? state.profile.firstName + ' ' + state.profile.lastName : '',
  // email: (state: State) => state.profile && state.profile.email ? state.profile.email : '',
  // _company: (state: State) => state.currentProfile && state.currentProfile._company ? state.currentProfile._company : null,
};

const mutations: MutationTree<State> = {
  loading(state: State) {
    state.loadStatus = "loading";
  },
  setup(state: State, profiles: Profile[]) {
    state.loadStatus = "success";
    state.profiles = profiles;
    Vue.axios.defaults.headers.common["LF-Badge"] = "default";
  },
  standCompaniesSetup(state: State, companies: Company[]) {
    state.standCompanies = companies;
  },
  userCompanySetup(state: State, company: Company) {
    state.userCompany = company;
  },
  error(state: State) {
    state.loadStatus = "error";
    state.profiles = [];
    state.userCompany = null;
    state.standCompanies = [];
  },
  clear(state: State) {
    state.loadStatus = "";
    state.profiles = [];
    state.userCompany = null;
    state.standCompanies = [];
    delete Vue.axios.defaults.headers.common["LF-Badge"];
  },
  setClientVersion(state: State, version: string) {
    state.versionClient = version;
  },
  setPlan(state: State, plan: string) {
    state.plan = plan;
  },

  setBadgeContacts(state: State, {badgeId, contacts}) {
    let editedContacts = state.profiles.filter(item => {
      if (item._id == badgeId) {
        item.contacts = contacts
      }

      return item
    })

    state.profiles = editedContacts
  },

  setBadgeLinks(state: State, {badgeId, links}) {
    let editedContacts = state.profiles.filter(item => {
      if (item._id == badgeId) {
        item.promo = links
      }

      return item
    })

    state.profiles = editedContacts
  },

  addBadgeById(state: State, badge: any) {
    state.profiles = state.profiles.map(item => {
      if (item._id == badge._id) {
        return {...item, ...badge}
      }
      return item
    })
  },

  setUserCompany(state, company) {
    state.userCompany = {...state.userCompany, ...company}
  },
  setStandCompany(state, company) {
    state.standCompanies[0] = {...company}
  }
};

const actions: ActionTree<State, RootState> = {
  refresh({commit}, {showId, userCompanyId, exhibitor}) {
    return new Promise((resolve, reject) => {
      commit("loading");

      Vue.axios({
        url: "/query",
        method: "POST",
        data: `
          {
            "query": "query{Badges(_show:\\"${showId}\\"){count values{about barcode _company companyTitle contacts{id order title type value} _show _id locations{address city _country id order postcode region title}login name{first last gender}photo plan position promo{id order type value title}role settings{code value}standTitle thematics{id title child{title}}_user}}}",
            "variables": {}
          }
        `,
      })
        .then((resp: any) => {
          if (resp.data.status === 'ok') {
            commit("setup", resp.data.data.Badges.values)

            if (exhibitor) {
              Vue.axios({
                url: "/query",
                method: "POST",
                data: `
                  {
                    "query": "query{Exhibitor(_id:\\"${exhibitor}\\"){ _id companies plan }}"
                  }
                `,
              })
                .then((resp: any) => {
                  if (resp.data.status == "ok") {
                    commit(
                      "setPlan",
                      resp.data.data.Exhibitor.plan
                        ? resp.data.data.Exhibitor.plan
                        : "free"
                    );

                    let companyIds = resp.data.data.Exhibitor.companies;
                    companyIds.push(userCompanyId);

                    Vue.axios({
                      url: "/query",
                      method: "POST",
                      data: `
                        {
                          "query": "query{Companies(ids:[ ${companyIds
                        .map((company: Company) => {
                          return '\\"' + company + '\\"';
                        })
                        .join(
                          ", "
                        )} ]){count values{ contacts { id type title value order } _show title description locations{address city _country id order postcode region title} promo{id order type value title} _id standTitle }}}"
                        }
                      `,
                    })
                      .then((resp: any) => {
                        if (resp.data.status == "ok") {
                          commit(
                            "userCompanySetup",
                            resp.data.data.Companies.values.filter(
                              (c: Company) => c._id == userCompanyId
                            )[0]
                          );
                          commit(
                            "standCompaniesSetup",
                            resp.data.data.Companies.values.filter(
                              (c: Company) =>
                                companyIds.includes(c._id) &&
                                c._id != userCompanyId
                            )
                          );
                          resolve(resp);
                        } else {
                          reject();
                        }
                      })
                      .catch((err: any) => {
                        commit("error");
                        reject(err);
                      });
                  } else {
                    reject();
                  }
                })
                .catch((err: any) => {
                  commit("error")
                  reject(err)
                })
            } else {
              resolve(false)
            }
          } else {
            reject()
          }
        })
        .catch((err: any) => {
          commit("error")
          reject(err)
        })
    })
  },

  editCompanyContacts(state, contacts) {
    console.log(contacts);

    let companies = state.state.standCompanies.map(company => {
      ServerCompany.editCompanyContacts(company._id, contacts)
        .catch(err => {
          console.log(err)
        })

      return company.contacts = contacts
    })

    // state.commit('standCompaniesSetup', companies)
  },

  editBadgeContacts(state, badge) {

  }
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
